import { useMutation } from "@tanstack/react-query";
import { apiPost } from "../../lib/api-client";
import { decodeJwt } from "../../lib/jwt-decode";
import { useAuthStore } from "../../stores/authStore";

interface TokenPair {
  accessToken: string;
  refreshToken: string;
}

export function useRefreshToken() {
  const login = useAuthStore((state) => state.login);
  const user = useAuthStore((state) => state.user);

  return useMutation({
    mutationFn: (refreshToken: string) => {
      return apiPost<TokenPair>("/auth/refresh", { refreshToken });
    },
    onSuccess: (data) => {
      if (user) {
        login(user, data.accessToken, data.refreshToken);
      }
    },
  });
}

interface DevLoginParams {
  email: string;
  name?: string;
}

/**
 * 開発用ログインフック（開発環境のみ）
 * Google OAuthをスキップして直接ログイン
 */
export function useDevLogin() {
  const login = useAuthStore((state) => state.login);

  return useMutation({
    mutationFn: (params: DevLoginParams) => {
      return apiPost<TokenPair>("/auth/dev-login", params);
    },
    onSuccess: (data) => {
      const payload = decodeJwt(data.accessToken);
      if (payload) {
        login(
          {
            email: payload.email,
            name: payload.name,
            isAdmin: payload.role === "admin",
          },
          data.accessToken,
          data.refreshToken
        );
      }
    },
  });
}
